import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('pesagem', { params: { ...where, ...params } }),
        apirecebimentoweb.get('pesagem/count', { params: where }),
      ]);
      return { data, total };
    },

    async findPessoaDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('pesagem/pessoa/distinct', { params: where }),
      ]);
      return { data };
    },

    async findPessoaDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`pesagem/pessoa/distinct/${codigo}`),
      ]);
      return { data };
    },

    async findMotoristaDistinct(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('pesagem/motorista/distinct', { params: where }),
      ]);
      return { data };
    },

    async findMotoristaDistinctCodigo(_, { codigo }) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get(`pesagem/motorista/distinct/${codigo}`),
      ]);
      return { data };
    },

    async findPesagens(_, {
      tipo, where, ...params
    } = {}) {
      const { data } = await apirecebimentoweb.get('pesagem/detalhado', { params: { tipo, ...where, ...params } });
      return data;
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apirecebimentoweb.get(`pesagem/detalhado/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
